import React from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import Text from '../global/Text';
import theme from '../../constants/theme';
import fontMaker from '../../utils/font';
import { NpsQuestion } from '../../store/reducers/nps/type';

type Props = {
  question: NpsQuestion;
  value: string;
  onChange: (text: string) => void;
};

const NPSQuestionOpen = ({ question, value, onChange }: Props) => {
  const { t } = useTranslation('common');

  return (
    <View style={styles.root}>
      <Text style={styles.questionText}>{question.content}</Text>
      <TextInput
        style={styles.input}
        value={value}
        onChangeText={onChange}
        placeholder={t('nps.enterOpinion')}
        multiline
        maxLength={500}
        textAlignVertical="top"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  root: { flex: 1, padding: 16 },
  questionText: {
    ...fontMaker({ weight: 'SemiBold' }),
    fontSize: 15,
    color: theme.colors.darkgray,
    marginBottom: 16,
    lineHeight: 22
  },
  input: {
    borderWidth: 1,
    borderColor: theme.colors.gray,
    borderRadius: 8,
    padding: 12,
    minHeight: 120,
    fontSize: 14,
    color: theme.colors.darkgray,
    ...fontMaker({ weight: 'Normal' }),
    textAlignVertical: 'top'
  }
});

export default NPSQuestionOpen;
